export default __webpack_public_path__ + "static/media/img--bathroom-light.71c334c8.jpg";